<!--
 通用卡片内容组件，只显示卡片内容，不会有边框等装饰
 这是一个包装器，根据卡片类型选择用来展示的组件
 支持打字机效果（暂时只有挖空卡实现了打字机） 
 -->
<template>
  <ClozeCard
    v-if="props.card.type === CardType.CLOZE"
    :card="props.card"
    :enable-typewriter="props.enableTypewriter"
    :single-line="props.singleLine"
    @typewriter-complete="emit('typewriter-complete')"
  />

  <EnWordCard
    v-if="props.card.type === CardType.EN_WORD"
    :card="props.card"
    :word-only="props.singleLine"
  />

  <MCQCard
    v-if="props.card.type === CardType.MCQ"
    :card="props.card"
    :single-line="props.singleLine"
  />

  <KidHanziCard
    v-if="props.card.type === CardType.KID_HANZI"
    :card="props.card"
    :single-line="props.singleLine"
  />
</template>

<script lang="ts" setup>
import { type Card, CardType } from '@/types/core'
import ClozeCard from './ClozeCard.vue'
import EnWordCard from './EnWordCard.vue'
import MCQCard from './MCQCard.vue'
import KidHanziCard from './KidHanziCard.vue'

const props = defineProps<{
  /** 卡片数据 */
  card: Card
  /** 是否启用打字机效果 */
  enableTypewriter?: boolean
  /** 是否只显示单行内容 */
  singleLine?: boolean
}>()

const emit = defineEmits<{
  /** 打字机效果结束 */
  (e: 'typewriter-complete'): void
}>()
</script>
